import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-base',
  templateUrl: 'base.component.html',
  styles: []
})
export class BaseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
